<div
  class="flex items-start gap-4 p-5 bg-white border border-slate-200 rounded-xl shadow-sm transition-all duration-200 hover:shadow-md hover:border-slate-300 relative group"
>
  <!-- Drag Handle (Visual indicator) -->
  @if (isEditable) {
    <div
      class="flex-shrink-0 flex items-center justify-center text-slate-400 hover:text-slate-600 cursor-grab active:cursor-grabbing p-1 -ml-1 rounded transition-colors self-center"
      title="Drag to reorder"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2.5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8 9h.01M16 9h.01M8 15h.01M16 15h.01M12 9h.01M12 15h.01"
        />
      </svg>
    </div>
  }

  <!-- Number Circle -->
  <div
    class="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 border border-slate-200 text-slate-700 font-bold text-sm flex items-center justify-center self-center"
  >
    {{ index + 1 }}
  </div>

  <!-- Content -->
  <div class="flex-1 min-w-0">
    <div class="flex flex-wrap items-center gap-2 mb-2">
      <!-- Question Type Badge -->
      <span
        [class]="
          'text-xs font-semibold px-2.5 py-0.5 rounded-full border ' +
          getTypeBadgeClass(question.type)
        "
      >
        {{ getReadableType(question.type) }}
      </span>

      <!-- Required Indicator -->
      @if (question.required) {
        <span
          class="text-xs font-semibold px-2 py-0.5 rounded-full bg-rose-50 text-rose-700 border border-rose-200"
        >
          Required
        </span>
      }
    </div>

    <!-- Question Text -->
    <h4 class="text-base font-semibold text-slate-800 break-words pr-8">
      {{ question.text }}
    </h4>

    <!-- Choice Options Pills -->
    @if (question.options && question.options.length > 0) {
      <div class="mt-3">
        <p class="text-xs font-medium text-slate-500 mb-1.5">Options:</p>
        <div class="flex flex-wrap gap-1.5">
          @for (option of question.options; track $index) {
            <span
              class="inline-flex items-center text-xs font-medium px-2.5 py-1 rounded bg-slate-50 border border-slate-200 text-slate-600 shadow-sm"
            >
              {{ option }}
            </span>
          }
        </div>
      </div>
    }
  </div>

  <!-- Delete Actions -->
  @if (isEditable) {
    <div
      class="absolute right-4 top-4 md:relative md:right-0 md:top-0 flex-shrink-0 self-center opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity duration-150"
    >
      <button
        type="button"
        (click)="onDelete($event)"
        class="text-rose-500 hover:text-rose-700 hover:bg-rose-50 p-2 rounded-lg transition-colors border border-transparent hover:border-rose-100"
        title="Remove Question"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      </button>
    </div>
  }
</div>
